import { Component } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthService } from '@lg/ng-shared'

@Component({
	templateUrl: './no-studio-access.html',
	standalone: false,
})
export class NoStudioAccessComponent {
	constructor(
		private authService: AuthService,
		private route: ActivatedRoute,
	) {}

	logout() {
		this.authService.logout$().subscribe(() => {
			let redirect = this.route.snapshot.queryParamMap.get('redirect')
			if (redirect) redirect = `?redirect=${encodeURIComponent(redirect)}`
			window.location.replace(`/studio/login${redirect}`)
		})
	}
}
